import React from 'react';
import moment from 'moment';
import Translator from 'translator';
import ReactDOMServer from 'react-dom/server';
import { PrintMac } from 'data/components';
import { icons } from './index';

const JsBarcode = require('jsbarcode');

const tools = {
    isEmpty: value => {
        return value === null || /^\s*$/.test(value);
    },
    removeKey: (errorObject, deleteKey) => {
        const newErrorObject = { ...errorObject };
        delete newErrorObject[deleteKey];
        return newErrorObject;
    },
    checkEmptyFields: (form, fields) => {
        const errors = {};
        fields.forEach(field => {
            if (tools.isEmpty(form[field])) {
                errors[field] = Translator.translate('general.fields.error.any.empty');
            }
        });
        return errors;
    },
    handleFormError: fields => {
        const res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>,
                );
            });
        });

        return res;
    },
    maxFieldLength: (fieldsLength, form, target) => {
        const maxLength = fieldsLength[target.name];
        let value = target.value;
        if (maxLength && value.length > maxLength) {
            value = form[target.name];
        }
        return value;
    },
    sortVersion: (a, b) => {
        let compareA = '';
        let compareB = '';

        try {
            compareA = a.match(/\d+/g).map(x => +x + 1000);
        } catch (e) {
            return -1;
        }

        try {
            compareB = b.match(/\d+/g).map(x => +x + 1000);
        } catch (e) {
            return 1;
        }

        if (compareA === compareB) return 0;
        return compareA < compareB ? -1 : 1;
    },
    sortDate: (a, b) => {
        if (!a && !b) return 0;
        if (!a) return -1;
        if (!b) return 1;
        try {
            const fieldA = moment(a, 'DD/MM/YYYY hh:mm:ss');
            const fieldB = moment(b, 'DD/MM/YYYY hh:mm:ss');
            return fieldA.isAfter(fieldB) ? 1 : -1;
        } catch (e) {
            return -1;
        }
    },
    filterMacAddress: (value, filter, row) => {
        if (!value) return false;
        const formattedValue = value.toLowerCase().replace(/:/g, '');
        const formattedFilter = filter.value.toLowerCase().replace(/:/g, '');
        return formattedValue.indexOf(formattedFilter) !== -1;
    },
    mergePropsToAction: (ownProps, actions) => {
        let res = {};
        Object.keys(actions).map(actionName => {
            const action = actions[actionName];
            res[actionName] = (...restParams) => action(ownProps, ...restParams);
        });
        return Object.assign({}, res);
    },
    printLabel: ({ codePack, codeEnv, boxId, envBox, boxMac }) => {
        const printCodePack = codePack.toString().padStart(3, 0);
        const printCodeEnv = codeEnv.toString().padStart(4, 0);
        const printBoxId = boxId.toString().padStart(5, 0);

        let icon = icons[envBox].replace('./dist', '/dist').replace('./assets', '/assets');
        let mywindow = window.open('', 'PRINT');

        const checkReadyState = mywindow => {
            if (mywindow.document.readyState === 'complete') {
                clearInterval(printInterval);
                mywindow.focus(); // necessary for IE >= 10
                mywindow.print();
                mywindow.close();
            }
        };
        let printInterval = null;

        const textToBase64Barcode = (text, _options = {}) => {
            const defaultOptions = { format: 'ean13' };
            const options = Object.assign({}, defaultOptions, _options);
            const barcode = options.format === 'ean13' ? text.padStart(12, 0) : options.format === 'ean8' ? text.padStart(7, 0) : text;
            const canvas = document.createElement('canvas');
            JsBarcode(canvas, barcode, options);
            return canvas.toDataURL('image/png');
        };

        const formatMacAddress = () => {
            return boxMac.includes(':') ? boxMac : boxMac.match(/.{1,2}/g).join(':');
        };

        mywindow.document.write(`
            <html> 
                <body>
                    <div style="align-items: center; display: flex; justify-content: space-between;  margin: 1px auto auto auto;  position: relative; width: 300px;">
                        <img src=${icon} alt="env_logo" width="50" height="50"/>
                    <div style="padding: 8px">
                        <div style="margin-bottom: 6px; font-family: Oxygen,sans-serif;font-size: 18px; font-weight: bold;">BOX${printBoxId}ID</div>
                        <div style="margin-top: 6px; font-family: Oxygen,sans-serif;font-size: 18px; font-weight: bold;">${formatMacAddress()}</div>
                    </div>
        `);

        mywindow.document.write(ReactDOMServer.renderToStaticMarkup(<PrintMac boxId={printBoxId} />));
        mywindow.document.write(`
                    </div>
                </body>
            </html>
        `);

        mywindow.document.close(); // necessary for IE >= 10
        printInterval = setInterval(checkReadyState.bind(this, mywindow), 300);
        return true;
    },
    buildReactSelectArray: enums => {
        return enums.reduce((acc, enu) => {
            let label = enu;
            if (Translator.isTranslationExist(`general.productModules.${enu}`)) {
                label = Translator.translate(`general.productModules.${enu}`);
            }
            return [...acc, { value: enu, label }];
        }, []);
    },
};

export default tools;



// WEBPACK FOOTER //
// ./data/common/tools.js